/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetence,
    LearningCompetenceFromJSON,
    LearningCompetenceFromJSONTyped,
    LearningCompetenceToJSON,
} from './LearningCompetence';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';
import {
    SubjectLearningOutcome,
    SubjectLearningOutcomeFromJSON,
    SubjectLearningOutcomeFromJSONTyped,
    SubjectLearningOutcomeToJSON,
} from './SubjectLearningOutcome';

/**
 * 
 * @export
 * @interface SubjectMinimumPromotionOutcome
 */
export interface SubjectMinimumPromotionOutcome {
    /**
     * 
     * @type {string}
     * @memberof SubjectMinimumPromotionOutcome
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubjectMinimumPromotionOutcome
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubjectMinimumPromotionOutcome
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SubjectMinimumPromotionOutcome
     */
    subjectId?: string;
    /**
     * 
     * @type {Subject}
     * @memberof SubjectMinimumPromotionOutcome
     */
    subject?: Subject;
    /**
     * 
     * @type {string}
     * @memberof SubjectMinimumPromotionOutcome
     */
    learningCompetenceId?: string | null;
    /**
     * 
     * @type {LearningCompetence}
     * @memberof SubjectMinimumPromotionOutcome
     */
    learningCompetence?: LearningCompetence;
    /**
     * 
     * @type {string}
     * @memberof SubjectMinimumPromotionOutcome
     */
    subjectLearningOutcomeId?: string | null;
    /**
     * 
     * @type {SubjectLearningOutcome}
     * @memberof SubjectMinimumPromotionOutcome
     */
    subjectLearningOutcome?: SubjectLearningOutcome;
}

export function SubjectMinimumPromotionOutcomeFromJSON(json: any): SubjectMinimumPromotionOutcome {
    return SubjectMinimumPromotionOutcomeFromJSONTyped(json, false);
}

export function SubjectMinimumPromotionOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectMinimumPromotionOutcome {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'subject': !exists(json, 'subject') ? undefined : SubjectFromJSON(json['subject']),
        'learningCompetenceId': !exists(json, 'learningCompetenceId') ? undefined : json['learningCompetenceId'],
        'learningCompetence': !exists(json, 'learningCompetence') ? undefined : LearningCompetenceFromJSON(json['learningCompetence']),
        'subjectLearningOutcomeId': !exists(json, 'subjectLearningOutcomeId') ? undefined : json['subjectLearningOutcomeId'],
        'subjectLearningOutcome': !exists(json, 'subjectLearningOutcome') ? undefined : SubjectLearningOutcomeFromJSON(json['subjectLearningOutcome']),
    };
}

export function SubjectMinimumPromotionOutcomeToJSON(value?: SubjectMinimumPromotionOutcome | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'subjectId': value.subjectId,
        'subject': SubjectToJSON(value.subject),
        'learningCompetenceId': value.learningCompetenceId,
        'learningCompetence': LearningCompetenceToJSON(value.learningCompetence),
        'subjectLearningOutcomeId': value.subjectLearningOutcomeId,
        'subjectLearningOutcome': SubjectLearningOutcomeToJSON(value.subjectLearningOutcome),
    };
}

